






















import { Vue, Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class SearchInput extends Vue {
  @Prop() value: string | undefined;
  @Prop() listMethod!: Function;
  @Prop() placeholder: string | undefined;

  items: any = [];
  inputInFocus: boolean = false;

  get body() {
    return this.value;
  }

  set body(val: string | undefined) {
    this.$emit("input", val);
  }

  get isShowResults() {
    const inFocus = this.inputInFocus;
    const isHasResult = this.items?.length;

    return inFocus && isHasResult;
  }

  hide() {
    this.inputInFocus = false;
  }

  handleClick(item: any) {
    this.$emit("getItem", item);
    this.hide();
  }

  @Watch("value")
  async getItems() {
    this.items = await this.listMethod(this.body);
  }
}
